import React from "react";

import "./Headline.scss";

const Headline = () => {
	return (
		<div className="headline" id="About">
			<h1 className="title">Hi. I’m Talha.</h1>
			<h2 className="subtitle">
				Big thinker. Problem solver. Software Engineer.
			</h2>
		</div>
	);
};

export default Headline;
